import { render, staticRenderFns } from "./FormUnidadeAtendimento.vue?vue&type=template&id=37c579d3"
import script from "./FormUnidadeAtendimento.vue?vue&type=script&lang=js"
export * from "./FormUnidadeAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports